
import { defineComponent, SetupContext, ref, PropType, onMounted } from "vue";
import NativeClient from "@/client/native-client";
import { PantrySearchLineInfo, PantrySearchItemInfo, SearchFoodItem, FoodItem } from "@/types/pantry";
import { Recipe } from "@/types/recipes";
import PantrySearchListLineView from "./PantrySearchListLineView.vue";
import PantrySearchTagItem from "./PantrySearchTagItem.vue";
export default defineComponent({
  name: "PantrySearchView",
  components: {
    PantrySearchListLineView,
    PantrySearchTagItem
  },
  props: {
    list: {
      type: Array as PropType<Recipe[]>,
      default: () => []
    },
    searchFoodList: {
      type: Array as PropType<SearchFoodItem[]>,
      default: () => []
    },
    isShowList: {
      type: Boolean,
      default: false,
      requred: true
    }
  },
  setup(props, context: SetupContext) {
    interface HTMLElementEvent<T extends HTMLElement> extends Event {
      target: T;
    }
    const SWAIP_POSITION_VALUE = 70;
    const swaipBar = ref<HTMLDivElement>();
    const startX = ref(0);
    const startY = ref(0);
    const moveX = ref(0);
    const moveY = ref(0);

    const swipeUp = () => {
      // NativeClient.sendDebugLog("PantrySearchView swipeUp");
      context.emit("swipe-up");
    };

    const swipeDown = () => {
      // NativeClient.sendDebugLog("PantrySearchView swipeDown");
      context.emit("swipe-down");
    };

    const onTouchStartEvent = (e:TouchEvent) => {
      e.preventDefault();
      startX.value = e.touches[0].pageX;
      startY.value = e.touches[0].pageY;
      // NativeClient.sendDebugLog("PantrySearchView onTouchStartEvent startX=" + startX.value + " startY=" + startY.value);
    };

    const onTouchMoveEvent = (e:TouchEvent) => {
      e.preventDefault();
      moveX.value = e.touches[0].pageX;
      moveY.value = e.touches[0].pageY;
      // NativeClient.sendDebugLog("PantrySearchView onTouchMoveEvent moveX=" + moveX.value + " y=" + moveY.value);
    };

    const onTouchEndEvent = (e:TouchEvent) => {
      e.preventDefault();
      // NativeClient.sendDebugLog("PantrySearchView onTouchEndEvent");
      
      if (startY.value > moveY.value && startY.value > moveY.value + SWAIP_POSITION_VALUE) {
        // 下から上
        swipeUp();
      } else if (startY.value < moveY.value && startY.value + SWAIP_POSITION_VALUE < moveY.value) {
        // 上から下
        swipeDown();
      }
    };

    const setTouchEvent = () => {
      if (swaipBar.value == null) {
        return;
      }
      swaipBar.value.addEventListener("touchstart", onTouchStartEvent);
      swaipBar.value.addEventListener("touchmove", onTouchMoveEvent);
      swaipBar.value.addEventListener("touchend", onTouchEndEvent);
    };
    /**
     * コンポーネントがマウントされたときに通知される
     */
    onMounted(() => {
      // NativeClient.sendDebugLog("PantrySearchView onMounted");
      setTouchEvent();
      
    });

    const onClickClose = () => {
      context.emit("click-close");
    };

    const onClickSearch = () => {
      context.emit("click-search");
    };

    const onSelectRecipe = (id: number, type: string) => {
      context.emit("select-recipe", id, type);
    };

    const getList = () => {
      const list = Array<PantrySearchLineInfo>();
      if (props.list == null) {
        return list;
      }
      let i = 0; // 全データの位置
      let lineCount = 0; // １行分のデータID
      const listMaxCount = 3;  // 1行分の表示データ数
      let lineInfo = Array<PantrySearchItemInfo>();
      for (const recipe of props.list) {
        lineInfo.push(new PantrySearchItemInfo(i, recipe));
        // NativeClient.sendDebugLog("PantrySearchView getList i=" + i + " lineCount=" + lineCount);
        if (lineInfo.length == listMaxCount) {
          list.push(new PantrySearchLineInfo(lineCount, lineInfo));
          lineInfo = Array<PantrySearchItemInfo>();
          lineCount++;
        }
        i++;
      }
      const emptyCount = 3 - lineInfo.length;
      if (emptyCount != 0 && emptyCount != 3) {
        for (let i = 0; i < emptyCount; i++) {
          const id = props.list.length + i;
          lineInfo.push(new PantrySearchItemInfo(id, null));
        }
        list.push(new PantrySearchLineInfo(lineCount, lineInfo));
      }
      // NativeClient.sendDebugLog("PantrySearchView getList list=" + JSON.stringify(list));
      return list;
    };

    const isShowSearch = () => {
      return props.searchFoodList.length != 0;
    };

    const deleteFood = (data: FoodItem) => {
      context.emit("delete-food", data);
    };

    const onClickSearchConditions = () => {
      context.emit("click-search-dialog");
    };

    const isShowFoodTapMessage = () => {
      let result = true;
      NativeClient.sendDebugLog("PantrySearchView isShowFoodTapMessage props.isShowPantryList=" + props.isShowList);
      NativeClient.sendDebugLog("PantrySearchView isShowFoodTapMessage props.searchFoodList=" + props.searchFoodList);
      if (!props.isShowList) {
        result = false;
      } else {
        if (props.searchFoodList != null && props.searchFoodList.length != 0) {
          result = false;
        }
      }
      NativeClient.sendDebugLog("PantrySearchView isShowFoodTapMessage result=" + result);
      return result;
    };
    /**
     * スクロール時イベント
     */
     const onScroll = (e: HTMLElementEvent<HTMLDivElement>) => {
      // NativeClient.sendDebugLog(
      //   "PantryListView onScroll top=" +
      //     e.target.scrollTop +
      //     " height=" +
      //     e.target.offsetHeight +
      //     " total=" +
      //     (e.target.scrollTop + e.target.offsetHeight) +
      //     " scrollH=" +
      //     e.target.scrollHeight
      // );
      // データ初期化後のscrollTop=0では読み込まないようにする
      if (
        e.target.scrollTop != 0 &&
        e.target.scrollTop + e.target.offsetHeight >=
        e.target.scrollHeight - 1
      ) {
        NativeClient.sendDebugLog("PantrySearchView scrollEnd");
        context.emit("scroll-end");
      }
    };
    return {
      onClickClose,
      onClickSearch,
      swaipBar,
      getList,
      isShowSearch,
      deleteFood,
      onSelectRecipe,
      onClickSearchConditions,
      isShowFoodTapMessage,
      onScroll
    };
  }
});
